import { render, staticRenderFns } from "./AutoPayExtention.vue?vue&type=template&id=9f654d36&scoped=true"
import script from "./AutoPayExtention.vue?vue&type=script&lang=js"
export * from "./AutoPayExtention.vue?vue&type=script&lang=js"
import style0 from "./AutoPayExtention.vue?vue&type=style&index=0&id=9f654d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f654d36",
  null
  
)

export default component.exports